import React from 'react';
import { PropTypes } from 'prop-types';

import {
  Tooltip,
  Typography,
  IconButton,
  Icon,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import {
  SmallIconTextButton,
} from './SmallIconTextButton';

import { withStyles } from '@mui/styles';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
  },
  infoTipIcon: {
    position: 'relative',
    top: -4,
    marginLeft: theme.spacing(),
    fontSize: 14,
    fontWeight: 200,
    color: '#999999',
  },
  infoTip: {
    fontSize: 13,
    fontWeight: 200,
  },
  spacer: {
    flex: 1,
    minWidth: theme.spacing(2),
  },
  exportIcon: {
    fontSize: 16,
    fontWeight: 200,
  },
  menuIcon: {
    minWidth: 36,
  },
  rightLabel: {
    marginLeft: theme.spacing(),
    textAlign: 'right',
    fontSize: 13,
    fontWeight: 200,
    color: '#999999',
  },
});

class TitleTooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      exportMenuAnchor: null,
    };
  }

  handleExportClick = (event) => {
    const { onExport, onPdfExport } = this.props;
    
    // If only one option, trigger it directly
    if (onExport && !onPdfExport) {
      onExport();
      return;
    }
    if (onPdfExport && !onExport) {
      onPdfExport();
      return;
    }
    
    // Both options available, show menu
    this.setState({ exportMenuAnchor: event.currentTarget });
  };

  handleExportClose = () => {
    this.setState({ exportMenuAnchor: null });
  };

  handleCsvExport = () => {
    this.handleExportClose();
    if (this.props.onExport) {
      this.props.onExport();
    }
  };

  handlePdfExport = () => {
    this.handleExportClose();
    if (this.props.onPdfExport) {
      this.props.onPdfExport();
    }
  };

  render() {
    const {
      classes,
      title,
      tooltip,
      onExport,
      onPdfExport,
    } = this.props;
    const { exportMenuAnchor } = this.state;

    const hasExportOptions = onExport || onPdfExport;
    const hasBothOptions = onExport && onPdfExport;

    return (
      <div className={classes.container}>
        <Typography component='h2' variant='h6' color='primary' gutterBottom>
          {title}
        </Typography>
        { tooltip && (
          <Tooltip
            placement='bottom-start'
            title={(
              <Typography className={classes.infoTip}>
                {tooltip}
              </Typography>
          )}
          >
            <Icon className={classes.infoTipIcon}>info_outlined</Icon>
          </Tooltip>
        )}
        { hasExportOptions && (
          <>
            <Tooltip title="Download">
              <IconButton onClick={this.handleExportClick} size='large'>
                <Icon className={classes.exportIcon}>get_app</Icon>
              </IconButton>
            </Tooltip>
            {hasBothOptions && (
              <Menu
                anchorEl={exportMenuAnchor}
                open={Boolean(exportMenuAnchor)}
                onClose={this.handleExportClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <MenuItem onClick={this.handleCsvExport}>
                  <ListItemIcon className={classes.menuIcon}>
                    <TableChartIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>CSV</ListItemText>
                </MenuItem>
                <MenuItem onClick={this.handlePdfExport}>
                  <ListItemIcon className={classes.menuIcon}>
                    <PictureAsPdfIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>PDF</ListItemText>
                </MenuItem>
              </Menu>
            )}
          </>
        )}
        { this.props.onAction && (
        <>
          <div className={classes.spacer} />
          <SmallIconTextButton
            icon={this.props.actionIcon}
            text={this.props.actionText}
            onClick={this.props.onAction}
          />
        </>
        )}
        { this.props.rightLabel && (
          <>
            <div className={classes.spacer} />
            <Typography className={classes.rightLabel}>
              {this.props.rightLabel}
            </Typography>
          </>
        )}
      </div>
    );
  }
}

TitleTooltip.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  tooltip: PropTypes.string,
  onExport: PropTypes.func,
  onPdfExport: PropTypes.func,
  actionIcon: PropTypes.string,
  actionText: PropTypes.string,
  rightLabel: PropTypes.string,
  onAction: PropTypes.func,
};

const styled = withStyles(styles)(TitleTooltip);
export { styled as TitleTooltip };